import {
    useObtenerGridCentrosDashboard,
    useBuscarCentrosAutoComplete,
    exportarCentrosGrid
} from "../../Scripts/Services/contabilidad-service.js";
  import {
    AutoComplete,
    SelectButton,
    Dropdown,
    addLocale,
    Button,
    Column,
    DataTable,
    Calendar,
    ProgressSpinner,
    FilterMatchMode,
    FilterOperator,
    InputNumber,
    locale,
    Message,
    Row,
    ColumnGroup,
  } from 'primereact';
  import React, {useEffect, useState} from 'react';
import {createPortal} from "react-dom";
import Exportar from "../../../Commons/Scripts/Componentes/Exportar/Exportar";
import ToolTip from "../../../Commons/Scripts/Componentes/ToolTip/Tooltip";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
import { Dropdown as Dp, Nav } from 'react-bootstrap';
import {useTheme} from "../../../Commons/Scripts/Hooks";

export const GridContabilidad = () => {
    addLocale("es", {
        firstDayOfWeek: 1,
        showMonthAfterYear: true,
        dayNames: [
          "domingo",
          "lunes",
          "martes",
          "mi�rcoles",
          "jueves",
          "viernes",
          "s�bado",
        ],
        dayNamesShort: ["dom", "lun", "mar", "mi�", "jue", "vie", "s�b"],
        dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
        monthNames: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        monthNamesShort: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        today: "Hoy",
        equals: "Igual a",
        notEquals: "Diferente a",
        lt: "Menor a",
        lte: "Menor o igual a",
        gt: "Mayor a ",
        gte: "Mayor o igual a",
        is: "Is",
        isNot: "Is Not",
        before: "Before",
        after: "After",
        clear: "Limpiar",
        apply: "Aplicar",
        matchAll: "Coincidir todo",
        matchAny: "Coincidir cualquiera",
        addRule: "Agregar condicion",
        removeRule: "Quitar condicion",
      });
    const monedaPredeterminada = window.monedaPredeterminada;
    const {theme} = useTheme();
    const [showExportar, setShowExportar] = useState(false);
    const colorPrimario = window.colorPrimario;
    const [fechasGrid, setFechasGrid] = React.useState(null);
    // tabla
    const [centros, setTiendas] = React.useState([]);
    const [periodoGrid, setPeriodoGrid] = React.useState("mensual");
    const [filtros, setFiltros] = React.useState(null);
    const [cargandoData, setCargandoGrid] = React.useState(true);
    const [gridWhere, setGridWhere] = React.useState({
      where: {
        EsAscendente: false,
        EsOrdernable: true,
        OrderBy: "MargenNeto",
        IndiceDePagina: 0,
        esFecha: false,
        periodo: periodoGrid,
        CentrosNombreList: centros,
      },
    });
    const { data: centrosGrid, error: errorCentrosGrid } =
    useObtenerGridCentrosDashboard(gridWhere);
    const [totalRecords, setTotalRecords] = React.useState(0);
    const [lazyState, setlazyState] = React.useState({
      first: 0,
      rows: 10,
      page: 0,
      sortField: "MargenNeto",
      sortOrder: -1,
      filters: filtros,
    });
    const onPage = (event) => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          IndiceDePagina: event.page,
        },
      };
      setGridWhere(newWhere);
      setlazyState(event);
      setCargandoGrid(true);
    };
    const onSort = (event) => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          EsAscendente: event.sortOrder == 1,
          OrderBy: event.sortField,
        },
      };
      setGridWhere(newWhere);
      setlazyState(event);
      setCargandoGrid(true);
    };
    const onFilter = (event) => {
      const filtros = event.filters;
      setlazyState(event);
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          CentrosNombreList: filtros.Nombre.value,
          MargenBrutoFiltros: filtros.MargenBruto.constraints.map((e) => ({
            [e.value]: e.matchMode,
          })),
          MargenNetoFiltros: filtros.MargenNeto.constraints.map(
            (e) => ({
              [e.value]: e.matchMode,
            })
          ),
          MargenOperativoFiltros: filtros.MargenOperativo.constraints.map(
            (e) => ({
              [e.value]: e.matchMode,
            })
          ),
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
    };
    const borrarFiltros = () => {
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: fechasGrid?.[0] ?? null,
          fechaFin: fechasGrid?.[1] ?? null,
          CentrosNombreList: null,
          MargenBrutoFiltros: null,
          MargenNetoFiltros: null,
          MargenOperativoFiltros: null,
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
      initFiltros();
    };
    const initFiltros = () => {
      setFiltros({
        MargenBruto: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        MargenNeto: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        MargenOperativo: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
          ],
        },
        Nombre: {
          value: null,
          matchMode: FilterMatchMode.IN,
        },
      });
    };
    const formatearMargenOperativo = (rowData) => {
        return formatearTasa(rowData.MargenOperativo);
      };
      const formatearMargenBruto = (rowData) => {
        return formatearTasa(rowData.MargenBruto);
      };
      const formatearMargenNeto = (rowData) => {
        return formatearTasa(rowData.MargenNeto);
      };
    const formatearTasa = (value) => {
        value = value ?? 0.00;
        return `${value.toFixed(2)}%`;
      };
    const tasasFiltroTemplate = (options) => {
      return (
        <InputNumber
          value={options.value}
          onChange={(e) => options.filterCallback(e.value, options.index)}
          suffix="%"
        />
      );
    };
    const NombreFiltroTemplate = (options) => {
      return (
        <AutoComplete
          pt={{
            panel: { style: { width: "400px" } },
          }}
          onClick={(e) => autoCompleteRef.current.search(e, "", "dropdown")}
          ref={autoCompleteRef}
          emptyMessage="No hay resultados disponibles"
          showEmptyMessage="true"
          inputId="ac"
          value={options.value}
          multiple
          suggestions={dataFiltrada}
          completeMethod={buscarCentro}
          placeholder="Buscar Centros"
          onChange={(e) => options.filterCallback(e.value)}
          style={{ width: "400px" }}
        />
      );
    };
    //multiLookup
    const autoCompleteRef = React.useRef(null);
    const [where, setWhere] = React.useState({ where: {} });
    const { data } = useBuscarCentrosAutoComplete(where);
    const [dataFiltrada, setDataFiltrada] = React.useState(null);
    const [cargando, setCargando] = React.useState(true);
    const buscarCentro = (event) => {
      setWhere({ where: { Criterio: event.query, CantidadPorPagina: 1000 } });
    };
  
    //filtro periodos
    const [periodo, setPeriodo] = React.useState(1);
    const periodos = [
      { name: "Actual", value: 1 },
      { name: "Anterior", value: 2 },
      { name: "Otro", value: 3 },
    ];
    const [value, setValue] = React.useState(3);
    const [periodosPredifinidos, setPeriodosPredifinidos] = React.useState([]);
    const actual = [
      { name: "Hoy", value: 1 },
      { name: "Esta Semana", value: 2 },
      { name: "Este Mes", value: 3 },
      { name: "Este Trimestre", value: 4 },
      { name: "Este Año", value: 5 },
    ];
    const anterior = [
      { name: "Ayer", value: 6 },
      { name: "Semana Anterior", value: 7 },
      { name: "Mes Anterior", value: 8 },
      { name: "Trimestre Anterior", value: 9 },
      { name: "Año Anterior", value: 10 },
    ];
    function handleChange(value) {
      setValue(value);
      setCargandoGrid(true);
      let periodo;
      switch (value) {
        case 1:
          periodo = "diario";
          break;
        case 2:
          periodo = "semanal";
          break;
        case 3:
          periodo = "mensual";
          break;
        case 4:
          periodo = "trimestral";
          break;
        case 5:
          periodo = "anual";
          break;
        case 6:
          periodo = "ayer";
          break;
        case 7:
          periodo = "semana anterior";
          break;
        case 8:
          periodo = "mes anterior";
          break;
        case 9:
          periodo = "trimestre anterior";
          break;
        case 10:
          periodo = "ano anterior";
          break;
      }
      setPeriodoGrid(periodo);
      const newWhere = {
        where: {
          ...gridWhere.where,
          periodo: periodo,
          esFecha: false,
        },
      };
      setGridWhere(newWhere);
    }
    const [dates, setDates] = React.useState(null);
    let today = new Date();
    const [verRangoDeFechas, setVerRangoDeFechas] = React.useState(false);
  
    function setFechas() {
      setValue(null);
      const fechasFormateadas = dates.map((date) => formatDate(date));
      setFechasGrid(fechasFormateadas);
      const newWhere = {
        where: {
          ...gridWhere.where,
          fechaInicio: formatDate(dates[0]),
          fechaFin: formatDate(dates[1]),
          esFecha: true,
        },
      };
      setGridWhere(newWhere);
      setCargandoGrid(true);
    }
    function formatDate(date) {
      var date = new Date(date);
      var day = date.getDate();
      var month = date.getMonth() + 1;
      var year = date.getFullYear();
      return day + "/" + month + "/" + year;
    }
    const matchModes = [
      {
        label: "Mayor o igual a",
        value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
      },
      { label: "Menor o igual a", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];
    const header = () => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="p-component">
            <Button
              type="button"
              icon="pi pi-filter-slash"
              label="Limpiar Filtros"
              outlined
              onClick={borrarFiltros}
              id="quitarFiltros"
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              flexDirection: "column",
              alignItems: "center",
              minWidth: "50%",
            }}
          >
            <div style={{ width: "40%", marginBottom: "5px" }}>
              <Dropdown
                value={periodo}
                onChange={(e) => setPeriodo(e.value)}
                options={periodos}
                optionLabel="name"
              />
            </div>
  
            {verRangoDeFechas ? (
              <div>
                <Calendar
                  maxDate={today}
                  placeholder="Rango de Fechas"
                  dateFormat="dd/mm/yy"
                  value={dates}
                  selectionMode="range"
                  locale="es"
                  onChange={(e) => setDates(e.value)}
                />
              </div>
            ) : (
              <SelectButton
                value={value}
                onChange={(e) => handleChange(e.value)}
                optionLabel="name"
                options={periodosPredifinidos}
              />
            )}
          </div>
            <div>
                <Dp as={Nav.Item}>
                    <Dp.Toggle
                        as={Nav.Link}
                        id="Dp-company-switch"
                        className="buttonHover"
                        onClick={openExportar}
                    >
                        <ToolTip placement="left" message="Exportar">
                            <SvgComponent
                                iconName="export"
                                fill={theme.color1}
                            />
                        </ToolTip>
                    </Dp.Toggle>
                </Dp>
            </div>
        </div>
      );
    };
    const colmunas = [
      {
        field: "MargenNeto",
        header: "Margen Neto",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearMargenNeto
      },
      {
        field: "MargenBruto",
        header: "Margen Bruto",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearMargenBruto
      },
      {
        field: "MargenOperativo",
        header: "Margen Operativo",
        dataType: "numeric",
        filterElement: tasasFiltroTemplate,
        body: formatearMargenOperativo
      },
    ];
    const openExportar = () => {
        setShowExportar(true);
    };
    // useEffect
    React.useEffect(() => {
      locale("es");
      initFiltros();
    }, []);
    React.useEffect(() => {
      if (data) {
        let _centrosFiltrados = [];
        _centrosFiltrados = data.Resultados.map((e) => {
          return e.text;
        });
        setDataFiltrada(_centrosFiltrados);
      }
    }, [data]);
    React.useEffect(() => {
      if (centrosGrid && !errorCentrosGrid) {
        setTotalRecords(centrosGrid.total);
        setCargando(false);
        setCargandoGrid(false);
      } else if (centrosGrid) {
        setTotalRecords(centrosGrid.total);
        setCargando(false);
        setCargandoGrid(false);
      }
      setCargandoGrid(false);

    }, [centrosGrid]);
    React.useEffect(() => {
      if (dates) {
        if (dates[0] !== null && dates[1] !== null) {
          setFechas();
        }
      }
    }, [dates]);
    React.useEffect(() => {
      if (periodo == 1) {
        setPeriodosPredifinidos(actual);
        setVerRangoDeFechas(false);
      } else if (periodo == 2) {
        setPeriodosPredifinidos(anterior);
        setVerRangoDeFechas(false);
      } else {
        setVerRangoDeFechas(true);
      }
    }, [periodo]);
    React.useEffect(() => {
      setlazyState({
        ...lazyState,
        filters: filtros,
      });
    }, [filtros]);
  
    return (
      <div className="new-p-table">
        {cargando ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ProgressSpinner />
          </div>
        ) : (
          <>
              {showExportar && createPortal(
                  <Exportar
                      PROPIEDADES_EXPORTAR={[
                          {value: 'IdSec', label: 'Id'},
                          {value: 'Nombre', label: 'Nombre'},
                          {value: 'MargenNeto', label: 'Margen Neto'},
                          {value: 'MargenBruto', label: 'Margen Bruto'},
                          {value: 'MargenOperativo', label: 'Margen Operativo'},
                          
                      ]}
                      where={{...gridWhere.where}}
                      showExportar={showExportar}
                      setShowExportar={setShowExportar}
                      exportarCallBack={exportarCentrosGrid}
                  >
                  </Exportar>,
                  window.parent.document.querySelector("#sidebarContainer")
              )}
            <div>
              {errorCentrosGrid && (
                <Message
                  severity="warn"
                  text={errorCentrosGrid?.Mensaje}
                  style={{ width: "100%", marginBottom: "10px" }}
                />
              )}
            </div>
            <DataTable
              showGridlines
              header={header}
              onFilter={onFilter}
              filters={lazyState.filters}
              value={centrosGrid.centros}
              lazy
              first={lazyState.first}
              rows={25}
              loading={cargandoData}
              paginator
              totalRecords={totalRecords}
              onPage={onPage}
              onSort={onSort}
              sortField={lazyState.sortField}
              sortOrder={lazyState.sortOrder}
              tableStyle={{ minWidth: "50rem" }}
              stripedRows
              size="small"
              emptyMessage="No hay resultados disponibles."
              resizableColumns
              columnResizeMode="expand"
              pt={{
                paginator: {
                  pageButton: "p-component",
                  nextPageButton: "p-component",
                  lastPageButton: "p-component",
                  prevPageButton: "p-component",
                  firstPageButton: "p-component",
                },
              }}
            >
          <Column
            style={{ textAlign: "right" }}
            sortable
            field="IdSec"
            header="ID"
          />
          <Column
            style={{ minWidth: "15rem" }}
            sortable
            field="Nombre"
            header="Centros"
            showFilterMatchModes={false}
            filter
            filterField="Nombre"
            filterElement={NombreFiltroTemplate}
            pt={{
              filterMenuButton: { className: "p-component" },
              filterButtonbar: { className: "test" },
            }}
          />
          {colmunas.map((col, i) => (
            <Column
              style={{ minWidth: "5rem", textAlign:'right' }}
              pt={{
                filterMenuButton: { className: "p-component" },
                filterButtonbar: { className: "test" },
              }}
              sortable
              field={col.field}
              header={col.header}
              body={col.body}
              filter
              sortField={col.field}
              filterField={col.field}
              filterElement={col.filterElement}
              dataType={col.dataType}
              showFilterOperator={false}
              filterMatchModeOptions={matchModes}
            />
          ))}
            </DataTable>
          </>
        )}
      </div>
    );
  };
